module.exports = __webpack_public_path__ + "static/marine_video-920e97c16728526d12ab57549bd102fb.mp4";